/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SatisfactionSurveyData = {
    properties: {
        id: {
    type: 'number',
},
        surveyId: {
    type: 'number',
    isRequired: true,
},
        questionId: {
    type: 'number',
    isRequired: true,
},
        comment: {
    type: 'string',
    isRequired: true,
},
        meet: {
    type: 'boolean',
    isRequired: true,
},
        skipQuestion: {
    type: 'boolean',
    isRequired: true,
},
    },
};